import * as React from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Typography from "@mui/material/Typography";
import { Button, IconButton, useMediaQuery, useTheme, } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import EditHeading from './bot-profile-chat/EditHeading';
import NewLiveLocationDetails from './bot-profile-chat/NewLiveLocationDetails';
import UserInfoSection from './bot-profile-chat/UserInfoSection';
import EditAboutInfo from './bot-profile-chat/EditAboutInfo';
import EditAboutLonging from './bot-profile-chat/EditAboutLonging';
import EditLuxeInfo from './bot-profile-chat/EditLuxeInfo';
import VerificationSection from './bot-profile-chat/VerificationSection';
import UserPhotosLayout from './bot-profile-chat/UserPhotosLayout';

export default function RealUserProfile({ open, toggleDrawer, userData }) {
  const list = () => (
    <Box
      sx={{
        width: 380,
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
      role="presentation"
    >

      {/* ---------- HEADER (fixed) ---------- */}
      <Box
        sx={{
          p: 2,
          borderBottom: "1px solid #eee",
          position: "sticky",
          top: 0,
          backgroundColor: "#fff",
          zIndex: 10,
        }}
      >
        <IconButton
          onClick={toggleDrawer(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: '14px',
            width: '35px',
            height: '35px',
            border: '1px solid #ccc'
          }}
          size="small"
        >
          <ArrowForwardIosIcon sx={{ fontSize: '18px' }} />
        </IconButton>

        <Typography variant="h6" textAlign="center" fontWeight={600}>
          Profile Details
        </Typography>
      </Box>

      {/* ---------- BODY (scrollable) ---------- */}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          p: 2,
          pb: 10,  // space for footer
        }}
      >
        <UserPhotosLayout
          photos={userData?.publicPhotos || []}
          title="Public Photos"
          isEditable={false}
          showExtraCount={true}
          isTitleHide={false}
          classCardMedia="Rtmedia"
          classTitlebg="Rttitlebg"
          classTitle="Rttitle"
          classTotalPhoto="Rttotalphoto"
          height70Img="height70Img"
        />
        {/* <UserPhotosLayout
          photos={userData?.privatePhotos || []}
          title="Private Photos"
          isEditable={false}
          showExtraCount={true}
          classCardMedia="Rtmedia"
          classTitlebg="Rttitlebg"
          classTitle="Rttitle"
          classTotalPhoto="Rttotalphoto"
          height70Img="height70Img"
        /> */}
        {
          userData?.myHeading &&
          <EditHeading
            myHeading={userData?.myHeading}
            isEditBtn={false}
            className="pdx"
            font16in14="fonmgset"
          />
        }
        <NewLiveLocationDetails userData={userData} />

        <UserInfoSection
          memberData={userData}
          isEditBtn={false}
          fieldsToShow={['Gender', 'Occupation', 'Height', 'Relationship', 'Who are you interested in', 'Location',"Intent"]}
          className="pdx"
          classflexinBlock="flexinBlock"
        />

        {userData?.aboutUsDescription && <EditAboutInfo memberData={userData} isEditBtn={false} className="pdx" font16in14="fonmgset" />}
        {/* {userData?.preferences?.aboutPartnerDescription && <EditAboutLonging memberData={userData} isEditBtn={false} className="pdx" font16in14="fonmgset" isRtsdbtnchat="px14font" />} */}
        {/* {userData?.luxuryInterests && <EditLuxeInfo memberData={userData} isEditBtn={false} className="pdx" isRtsdbtnchat="px14font" />} */}
        {
          (
            userData?.isInstagramVerified ||
            userData?.isLinkedinVerified ||
            userData?.isFacebookVerified ||
            userData?.isTwitterVerified ||
            userData?.isProfileVerified ||
            userData?.isIdVerified
          ) &&
          <VerificationSection memberData={userData} showOnlyVerified className="pdx" font16in14="fonmgset" />
        }
      </Box>
    </Box>
  );

  return (
    <SwipeableDrawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      sx={{
        zIndex: 2200,
      }}
    >
      {list()}
    </SwipeableDrawer>
  );
}
